// extracted by mini-css-extract-plugin
export default {"ConfigError":"ConfigError_ConfigError__4MbKf","card":"ConfigError_card__6+etO","body":"ConfigError_body__HFjJD","details":"ConfigError_details__iFbil"};